import styled from 'styled-components';

export const MarkdownTable = styled.table`
  width: 100%;
  table-layout: auto;
  tbody {
    border: 1px solid ${({ theme }) => theme.palette.gray87};
  }
  tr:nth-child(even) {
    background-color: ${({ theme }) => theme.palette.lynxWhite};
  }
  td,
  th {
    padding: 30px 15px;
    text-align: center;
    width: max-content;
    white-space: nowrap;
    border: 1px solid ${({ theme }) => theme.palette.gray87};
    border-collapse: collapse;
    font-size: 12px;
    line-height: normal;
    letter-spacing: normal;
    color: ${({ theme }) => theme.palette.darkGrey};
    a {
      color: ${({ theme }) => theme.palette.darkGrey};
    }
  }
  th {
    font-weight: bold;
  }
`;
